@if (list || user) {
<header
  class="my-3 d-flex flex-row align-items-center align-items-md-start flex-wrap flex-md-nowrap"
>
  <epc-list-user
    [user]="user"
    [date]="dateUtc"
    class="order-2 order-md-1 d-flex flex-nowrap"
  ></epc-list-user>
  <div
    class="order-1 order-md-2 mb-4 mb-md-0 px-2 d-flex flex-column align-items-center flex-grow-1 text-content"
  >
    <epc-list-header-text
      [list]="list"
      [lookBook]="lookBook"
      [showLookBookName]="showLookBookTitle$ | async"
      class="text-center d-flex flex-column align-items-center"
    ></epc-list-header-text>
    <span class="text-muted mt-1">
      {{ productCountText }}
    </span>
  </div>
  <div
    class="order-3 order-md-3 ml-auto actions-wrapper pointer-events-auto d-flex"
    [class.order-3]="(isMobile$ | async) === true"
  >
    <ng-content></ng-content>
  </div>
</header>
} @if ((showDescription$ | async) === true) {
<ng-container
  *epcFeatureFlag="
    showDescriptionEditor;
    namespace: productListNamespace;
    equality: true;
    defaultValue: false
  "
>
  @if (list?.description; as description) {
  <p
    class="description my-2 px-md-5 text-muted text-center"
    data-e2e="list-description"
    [innerHtml]="
      description | atxRemoveMarkdown | markdown | async | safeHtml: true
    "
  ></p>
  }
</ng-container>
<ng-container
  *epcFeatureFlag="
    showDescriptionEditor;
    namespace: productListNamespace;
    equality: false;
    defaultValue: false
  "
>
  @if (list?.description; as description) {
  <p
    class="description my-2 px-md-5 text-muted text-center"
    data-e2e="list-description"
  >
    {{ description }}
  </p>
  }
</ng-container>
}
